import { BankAccountType, AchAccountType, InvestmentAccountType, InvestmentAmountType } from '@egw/api'
import { type TransferAccounts, TransferField, type TransferListOption } from '../../types/form-model/form-model'

export const FROM_KEY = TransferField.From
export const TO_KEY = TransferField.To
export const AMOUNT_KEY = TransferField.Amount

export const CHECKING_TRANSFERABLE_TO_ACCOUNT: TransferAccounts[] = [
  BankAccountType.HIGH_YIELD_CHECKING,
  BankAccountType.LIQUID_TREASURIES,
  BankAccountType.HIGH_YIELD_SAVINGS,
  AchAccountType.SAVING,
  AchAccountType.CHECKING,
  InvestmentAccountType.BROKERAGE,
  InvestmentAccountType.ROTH_IRA,
  InvestmentAccountType.TRADITIONAL_IRA,
  InvestmentAccountType.JOINT_BROKERAGE_TIC,
  InvestmentAccountType.JOINT_BROKERAGE_JTWROS,
  InvestmentAccountType.JOINT_BROKERAGE_TBTE,
  InvestmentAccountType.COMPANION_JOINT_BROKERAGE_TBTE,
  InvestmentAccountType.JOINT_BROKERAGE_CP,
  InvestmentAccountType.COMPANION_JOINT_BROKERAGE_CP,
]

export const SAVINGS_TRANSFERABLE_TO_ACCOUNTS: TransferAccounts[] = [BankAccountType.HIGH_YIELD_CHECKING]

export const INVESTMENT_TRANSFERABLE_TO_ACCOUNTS: TransferAccounts[] = [
  BankAccountType.HIGH_YIELD_CHECKING,
  BankAccountType.LIQUID_TREASURIES,
]

export const INVESTMENT_COMPANION_TRANSFERABLE_TO_ACCOUNTS: TransferAccounts[] = []

export const INVESTMENT_INHERITED_TRANSFERABLE_TO_ACCOUNTS: TransferAccounts[] = []

export const LINKED_TRANSFERABLE_TO_ACCOUNTS: TransferAccounts[] = [
  BankAccountType.HIGH_YIELD_CHECKING,
  BankAccountType.LIQUID_TREASURIES,
]

export const TRANSFERABLE_ACCOUNTS_DICTIONARY: Record<TransferAccounts, TransferAccounts[]> = {
  [BankAccountType.LIQUID_TREASURIES]: CHECKING_TRANSFERABLE_TO_ACCOUNT,
  [BankAccountType.HIGH_YIELD_CHECKING]: CHECKING_TRANSFERABLE_TO_ACCOUNT,
  [BankAccountType.HIGH_YIELD_SAVINGS]: SAVINGS_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.BROKERAGE]: INVESTMENT_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.ROTH_IRA]: INVESTMENT_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.TRADITIONAL_IRA]: INVESTMENT_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.ROTH_IRA_INHERITED]: INVESTMENT_INHERITED_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.TRADITIONAL_IRA_INHERITED]: INVESTMENT_INHERITED_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.COMPANION_BROKERAGE]: INVESTMENT_COMPANION_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.COMPANION_ROTH_IRA]: INVESTMENT_COMPANION_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.COMPANION_IRA]: INVESTMENT_COMPANION_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.JOINT_BROKERAGE_JTWROS]: INVESTMENT_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.JOINT_BROKERAGE_TIC]: INVESTMENT_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.COMPANION_JOINT_BROKERAGE_TIC]: INVESTMENT_COMPANION_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.COMPANION_JOINT_BROKERAGE_JTWROS]: INVESTMENT_COMPANION_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.JOINT_BROKERAGE_TBTE]: INVESTMENT_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.COMPANION_JOINT_BROKERAGE_TBTE]: INVESTMENT_COMPANION_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.JOINT_BROKERAGE_CP]: INVESTMENT_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.COMPANION_JOINT_BROKERAGE_CP]: INVESTMENT_COMPANION_TRANSFERABLE_TO_ACCOUNTS,
  [AchAccountType.CHECKING]: LINKED_TRANSFERABLE_TO_ACCOUNTS,
  [AchAccountType.SAVING]: LINKED_TRANSFERABLE_TO_ACCOUNTS,
}

const APEX_LINKED_TRANSFERABLE_TO_ACCOUNTS: TransferAccounts[] = [
  InvestmentAccountType.BROKERAGE,
  InvestmentAccountType.ROTH_IRA,
  InvestmentAccountType.TRADITIONAL_IRA,
  InvestmentAccountType.JOINT_BROKERAGE_JTWROS,
  InvestmentAccountType.JOINT_BROKERAGE_TIC,
  InvestmentAccountType.JOINT_BROKERAGE_TBTE,
  InvestmentAccountType.JOINT_BROKERAGE_CP,
]

const APEX_INVESTMENT_TRANSFERABLE_TO_ACCOUNTS: TransferAccounts[] = [AchAccountType.SAVING, AchAccountType.CHECKING]

export const TRANSFERABLE_ACCOUNTS_DICTIONARY_APEX_MIGRATION: Record<TransferAccounts, TransferAccounts[]> = {
  [BankAccountType.LIQUID_TREASURIES]: [],
  [BankAccountType.HIGH_YIELD_CHECKING]: [],
  [BankAccountType.HIGH_YIELD_SAVINGS]: [],
  [AchAccountType.SAVING]: APEX_LINKED_TRANSFERABLE_TO_ACCOUNTS,
  [AchAccountType.CHECKING]: APEX_LINKED_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.BROKERAGE]: APEX_INVESTMENT_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.JOINT_BROKERAGE_JTWROS]: APEX_INVESTMENT_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.JOINT_BROKERAGE_TIC]: APEX_INVESTMENT_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.JOINT_BROKERAGE_TBTE]: APEX_INVESTMENT_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.JOINT_BROKERAGE_CP]: APEX_INVESTMENT_TRANSFERABLE_TO_ACCOUNTS,
  [InvestmentAccountType.COMPANION_BROKERAGE]: [],
  [InvestmentAccountType.COMPANION_ROTH_IRA]: [],
  [InvestmentAccountType.COMPANION_IRA]: [],
  [InvestmentAccountType.COMPANION_JOINT_BROKERAGE_TIC]: [],
  [InvestmentAccountType.COMPANION_JOINT_BROKERAGE_JTWROS]: [],
  [InvestmentAccountType.COMPANION_JOINT_BROKERAGE_TBTE]: [],
  [InvestmentAccountType.COMPANION_JOINT_BROKERAGE_CP]: [],
  [InvestmentAccountType.ROTH_IRA_INHERITED]: [],
  [InvestmentAccountType.TRADITIONAL_IRA_INHERITED]: [],
  [InvestmentAccountType.ROTH_IRA]: [],
  [InvestmentAccountType.TRADITIONAL_IRA]: [],
}

export const APEX_WITHDRAWABLE_ACCOUNTS: TransferAccounts[] = [
  InvestmentAccountType.BROKERAGE,
  InvestmentAccountType.JOINT_BROKERAGE_JTWROS,
  InvestmentAccountType.JOINT_BROKERAGE_TIC,
  InvestmentAccountType.JOINT_BROKERAGE_TBTE,
  InvestmentAccountType.JOINT_BROKERAGE_CP,
]

export const nullTransferFieldOptionv2: TransferListOption = {
  value: '',
  display: {
    name: '',
    subtitle: '',
    isHidden: true,
    isEvergreenAccount: false,
  },
  accountType: BankAccountType.HIGH_YIELD_CHECKING,
  alias: -1,
  transferableToAccounts: [],
  isDisabled: false,
  attributes: undefined,
}
